import { useState } from "react";
import useAxiosInstance from "../../../../../Utilities/Hooks/useAxiosInstance";
import Form from "../../../../Partials/Layouts/Forms/Form";
import ShortTextInput from "../../../../Partials/Layouts/Forms/FormInputs/ShortTextInput/ShortTextInput";
import FormSubmitButton from "../../../../Partials/Layouts/Forms/FormSubmitButton/FormSubmitButton";
import SwitchInput from "../../../../Partials/Layouts/Forms/FormInputs/SwitchInput/SwitchInput";
import ImageInput from "../../../../Partials/Layouts/Forms/FormInputs/ImageInput/ImageInput";
import { BLOGS_API } from "../../../../../Utilities/APIs/APIs";
import CustomEditor from "../../../../Partials/Elements/CustomEditor/CustomEditor";

function CreateBlog({ triggerFetch, setShowCreateForm }) {
  const axiosInstance = useAxiosInstance();

  const [title, setTitle] = useState("");
  const [category, setCategory] = useState("");
  const [excerpt, setExcerpt] = useState("");
  const [sectionOneTitle, setSectionOneTitle] = useState("Designed for everyday wear.");
  const [sectionOneText, setSectionOneText] = useState("");
  const [sectionTwoTitle, setSectionTwoTitle] = useState("Clean. Effortless. Repeatable.");
  const [sectionTwoText, setSectionTwoText] = useState("");
  const [precedence, setPrecedence] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  const [image, setImage] = useState(null);
  const [secondImage, setSecondImage] = useState(null);

  async function handleSubmit(e) {
    e.preventDefault();

    const itemData = new FormData();

    itemData.append("title", title);
    itemData.append("category", category);
    itemData.append("excerpt", excerpt);
    itemData.append("sectionOneTitle", sectionOneTitle);
    itemData.append("sectionOneText", sectionOneText);
    itemData.append("sectionTwoTitle", sectionTwoTitle);
    itemData.append("sectionTwoText", sectionTwoText);
    itemData.append("precedence", precedence);
    itemData.append("isVisible", isVisible);

    if (image) itemData.append("image", image);
    if (secondImage) itemData.append("secondImage", secondImage);

    const response = await axiosInstance.post(BLOGS_API, itemData);

    if (response) {
      triggerFetch();
      setShowCreateForm(false);
    }
  }

  return (
    <div className="crate_form">
      <Form onSubmit={handleSubmit}>
        <div>
          <ShortTextInput label="Title" value={title} placeholder="Enter Title" setState={setTitle} />

          <ShortTextInput label="Category" value={category} placeholder="Enter Category" setState={setCategory} />

          <ShortTextInput label="Quotation" value={excerpt} placeholder="Enter Quotation" setState={setExcerpt} />

          <ShortTextInput label="Section One Title" value={sectionOneTitle} placeholder="Enter Section One Title" setState={setSectionOneTitle} />

          <label
            style={{
              display: "block",
              fontWeight: 600,
              fontSize: "1.6rem",
              lineHeight: "2rem",
              color: "#E6E6E6",
              textTransform: "capitalize",
              marginBottom: "1.4rem",
            }}
          >
            Section One Text
          </label>

          <CustomEditor
            value={sectionOneText}
            setState={setSectionOneText}
            placeholder="Section One Text…"
          />
          <ShortTextInput label="Section Two Title" value={sectionTwoTitle} placeholder="Enter Section Two Title" setState={setSectionTwoTitle} />

          <label
            style={{
              display: "block",
              fontWeight: 600,
              fontSize: "1.6rem",
              lineHeight: "2rem",
              color: "#E6E6E6",
              textTransform: "capitalize",
              marginBottom: "1.4rem",
            }}
          >
            Section Two Text
          </label>

          <CustomEditor
            value={sectionTwoText}
            setState={setSectionTwoText}
            placeholder="Section Two Text…"
          />

          <ShortTextInput label="Precedence" value={precedence} placeholder="Enter Precedence" setState={setPrecedence} />

           <ImageInput
                        fieldId="1"
                        state={image}
                        setState={setImage}
                        allowCreateImage
                    >
                        Upload Main Image
            </ImageInput>

            <ImageInput
                        fieldId="2"
                        state={secondImage}
                        setState={setSecondImage}
                        allowCreateImage
                    >
                        Upload Second Image
            </ImageInput>

          <SwitchInput
            label="Visibility"
            toggleSwitch={() => setIsVisible((prevState) => !prevState)}
            checked={isVisible}
          />
        </div>

        <FormSubmitButton text="Submit" />
      </Form>
    </div>
  );
}

export default CreateBlog;